import React from 'react'
import PropTypes from 'prop-types'

import './borderedArea.scss'

const BorderedArea = ({ children, title, summary }) => (
    <div className='bordered-area'>
        <div className='area-title'>
            {title && <h4>{title}</h4>}
            {summary && <div>{summary}</div>}
        </div>
        {children}
    </div>
)

BorderedArea.propTypes = {
    children: PropTypes.array,
    title: PropTypes.string,
    summary: PropTypes.any,
}

export default BorderedArea
